// Module
var code = "<customer-compliance-documents\n  customer-id=\"vm.customer.id\"\n  customer-name=\"vm.customer.name\"\n  customer-archived=\"vm.customer.archived\"\n></customer-compliance-documents>\n";
// Exports
module.exports = code;